"use strict";
export const selectFilteredChainIds = (state) => state.swapSettings.filteredChainIds;
